// CompanyCard.jsx
import React from "react";
import { Skeleton } from "antd"; // 导入antd的Skeleton组件

const CompanyCard = ({ cover, name, redirectUrl, loading }) => {
  return (
    <div className="company-card">
      {loading ? (
        <div className="company-card-content">
          <Skeleton active paragraph={{ rows: 1 }} />
          <Skeleton active />
        </div>
      ) : (
        <a href={redirectUrl} target="_blank" rel="noopener noreferrer">
          <div className="company-card-content">
            <img src={cover} alt="" />
            <div className="title">{name}</div>
          </div>
        </a>
      )}
    </div>
  );
};

export default CompanyCard;
